import { Button } from "../ui/Button/Button";
import { Typography } from "../ui/Typography/Typography";
import { Direction } from "../ui/icons";
import { ArrowIcon } from "../ui/icons/ArrowIcon";
import "./ActionPlanTimeline.scss";

interface ActionPlanRailProps {
  labels?: string[];
  onNavigate?: (direction: Direction) => void;
}

export const ActionPlanRail = ({ labels, onNavigate }: ActionPlanRailProps) => {
  if (!labels || labels.length === 0) return null;

  return (
    <div className="ActionPlanRail">
      <div className="ActionPlanRail__nav ActionPlanRail__nav--left">
        <Button
          variant="outlined"
          color="secondary"
          icon
          onClick={() => onNavigate?.(Direction.LEFT)}
        >
          <ArrowIcon direction={Direction.LEFT} />
        </Button>
      </div>

      <div className="ActionPlanRail__bar">
        {labels.map((label) => (
          <Typography key={label} desktop="body2">
            {label}
          </Typography>
        ))}
      </div>

      <div className="ActionPlanRail__nav ActionPlanRail__nav--right">
        <Button
          variant="outlined"
          color="secondary"
          icon
          onClick={() => onNavigate?.(Direction.RIGHT)}
        >
          <ArrowIcon direction={Direction.RIGHT} />
        </Button>
      </div>
    </div>
  );
};
